import * as angular from "angular";
import {IController} from "angular";

export class resourceAllocationAgentAssignmentQueryTableRowCtrl implements IController {

  agentBinding: any;
  showAvailability: boolean;
  onAssign: Function;

  /* @ngInject */
  constructor() {
  }

}

angular
  .module('bringoz.admin.resources')
  .component('resourceAllocationAgentAssignmentQueryTableRow', {
    bindings: {
      agentBinding: '<',
      showAvailability: '@?',
      onAssign: '&'
    },
    template: require('./resource-allocation-agent-assignment-query-table-row.html').default,
    controller: resourceAllocationAgentAssignmentQueryTableRowCtrl
  });
